import React, { useState } from 'react';
import { withFormikSupport } from '@fourthwall/components';
import { ColorSelection } from '../../components/ColorSelection/ColorSelection';
export const ColorComponent = ({ data, value, onChange, onSettingUpdate }) => {
    const { id, label, value: initialValue, info } = data;
    const [lastValue, setLastValue] = useState(initialValue);
    const handleBlur = ({ color, isVariableUpdated, }) => {
        if (lastValue === color) {
            return;
        }
        setLastValue(color);
        onSettingUpdate(id, color, isVariableUpdated);
    };
    return (React.createElement(ColorSelection, { id: id, label: label, value: value, info: info, onChange: onChange, onBlur: handleBlur }));
};
export const Color = withFormikSupport(ColorComponent);
